<template>
  <div class="question_type_wrap">
    <div class="title">主要题型</div>
    <ul>
      <li
        class="type-item"
        @click="addQuestion('radio')"
      >
        <a href="javascript:;">
          <span class="icon">
            <i class="fa fa-dot-circle-o fa-lg"></i>
          </span>
          单选题
        </a>
      </li>
      <li
        class="type-item"
        @click="addQuestion('checkbox')"
      >
        <a href="javascript:;">
          <span class="icon">
            <i class="fa fa-check-square fa-lg"></i>
          </span>
          多选题
        </a>
      </li>
      <li
        class="type-item"
        @click="addQuestion('select')"
      >
        <a href="javascript:;">
          <span class="icon">
            <i class="fa fa-chevron-circle-down fa-lg"></i>
          </span>
          下拉题
        </a>
      </li>
      <li
        class="type-item"
        @click="addQuestion('input')"
      >
        <a href="javascript:;">
          <span class="icon">
            <i class="fa fa-font fa-lg"></i>
          </span>
          填空题
        </a>
      </li>
    </ul>

    <div class="title">常见题目</div>
    <ul>
      <li
        class="type-item"
        @click="addQuestion('reSurvey')"
      >
        <a href="javascript:;">
          <span class="icon">
            <i class="fa fa-mail-reply-all fa-lg"></i>
          </span>
          回访题
        </a>
      </li>
      <li
        class="type-item"
        @click="addQuestion('name')"
      >
        <a href="javascript:;">
          <span class="icon">
            <i class="fa fa-user fa-lg"></i>
          </span>
          姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名
        </a>
      </li>
      <li
        class="type-item"
        @click="addQuestion('gender')"
      >
        <a href="javascript:;">
          <span class="icon">
            <i class="fa fa-female fa-lg"></i>
          </span>
          性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别
        </a>
      </li>
      <li
        class="type-item"
        @click="addQuestion('mobilePhone')"
      >
        <a href="javascript:;">
          <span class="icon">
            <i class="fa fa-phone fa-lg"></i>
          </span>
          手机号
        </a>
      </li>
      <li
        class="type-item"
        @click="addQuestion('age')"
      >
        <a href="javascript:;">
          <span class="icon">
            <i class="fa fa-child fa-lg"></i>
          </span>
          年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;龄
        </a>
      </li>
      <li
        class="type-item"
        @click="addQuestion('address')"
      >
        <a href="javascript:;">
          <span class="icon">
            <i class="fa fa-map-marker fa-lg"></i>
          </span>
          地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址
        </a>
      </li>
      <li
        class="type-item"
        @click="addQuestion('satisfaction')"
      >
        <a href="javascript:;">
          <span class="icon">
            <i class="fa fa-question-circle fa-lg"></i>
          </span>
          满意度
        </a>
      </li>
    </ul>
    <!-- <div class="title">其他功能</div>
    <ul>
      <li class="type-item" @click="addQuestion('divider')">
        <a href="javascript:;">
          <span class="icon">
            <i class="fa fa-minus fa-lg"></i>
          </span>
          分隔符
        </a>
      </li>
    </ul> -->
  </div>
</template>

<script>
import uuid from "uuid";
export default {
  data() {
    return {
      timestamp: Date.parse(new Date())
    };
  },
  computed: {
    qorder: {
      get: function() {
        return this.$store.state.survey.surveyBody.questions.length;
      },
      set: function() {}
    }
  },
  methods: {
    // 处理添加题型的 click 事件
    // 其他 type 需要在 methods 定义方法
    addQuestion(type) {
      this.$store.dispatch("addQuestion", this[type]());
    },
    // 单选题
    radio() {
      return {
        id: uuid(this.timestamp),
        type: "radio",
        title: "单选题",
        description: "",
        order: ++this.qorder,
        setting: {
          // 题目是否显示
          visibility: {
            hidden: false, // 是否隐藏
            visible: {
              logic: "or", // and or
              options: [] // 记录哪些选项被选中的时候，该题目会显示
            }
          },
          required: true,
          random: false
        },
        options: [
          {
            id: uuid(this.timestamp),
            text: "选项 1",
            setting: {
              show: false,
              text: "",
              required: true,
              validate: ""
            }
          }
        ]
      };
    },
    // 多选题
    checkbox() {
      return {
        id: uuid(this.timestamp),
        type: "checkbox",
        title: "多选题",
        description: "",
        order: ++this.qorder,
        setting: {
          // 题目是否显示
          visibility: {
            hidden: false, // 是否隐藏
            visible: {
              logic: "or", // and or
              options: [] // 记录哪些选项被选中的时候，该题目会显示
            }
          },
          required: true,
          random: false
        },
        options: [
          {
            id: uuid(this.timestamp),
            text: "选项 1",
            setting: {
              show: false,
              text: "",
              required: true,
              validate: ""
            }
          }
        ]
      };
    },
    // 下拉题
    select() {
      return {
        id: uuid(this.timestamp),
        type: "select",
        title: "下拉题",
        description: "",
        order: ++this.qorder,
        setting: {
          // 题目是否显示
          visibility: {
            hidden: false, // 是否隐藏
            visible: {
              logic: "or", // and or
              options: [] // 记录哪些选项被选中的时候，该题目会显示
            }
          },
          required: true,
          random: false
        },
        options: [
          {
            id: uuid(this.timestamp),
            text: "选项 1",
            setting: {
              show: false,
              text: "",
              required: true,
              validate: ""
            }
          }
        ]
      };
    },
    // 输入题
    input() {
      return {
        id: uuid(this.timestamp),
        type: "input",
        title: "填空题",
        description: "",
        order: ++this.qorder,
        setting: {
          // 题目是否显示
          visibility: {
            hidden: false, // 是否隐藏
            visible: {
              logic: "or", // and or
              options: [] // 记录哪些选项被选中的时候，该题目会显示
            }
          },
          required: true,
          validate: "",
          maxlength: "",
          minlength: ""
        },
        options: []
      };
    },

    // 常见的题型
    // 回访题
    reSurvey() {
      let question = this.radio();
      question.title = "您是否接受我们的回访？";
      question.description =
        "如果您接受回访，我们的工作人员可能会在后续拨打您的电话询问您有关该问卷的一些问题。完成回访会有一定的奖励。";
      question.options = [
        {
          id: uuid(this.timestamp),
          text: "是",
          setting: {
            show: false,
            text: "",
            required: true,
            validate: ""
          }
        },
        {
          id: uuid(this.timestamp),
          text: "否",
          setting: {
            show: false,
            text: "",
            required: true,
            validate: ""
          }
        }
      ];
      return question;
    },

    // 姓名题
    name() {
      let question = this.input();
      question.title = "您的姓名是？";
      question.description = "请输入您的真实姓名";
      return question;
    },

    // 姓名题
    age() {
      let question = this.input();
      question.title = "您的年龄是？";
      question.description = "请输入您的周岁数";
      return question;
    },

    // 手机号
    mobilePhone() {
      let question = this.input();
      question.title = "您的手机号";
      question.description = "请输入您的手机号";
      return question;
    },

    // 快递地址
    address() {
      let question = this.input();
      question.title = "您的快递地址";
      question.description = "请输入您的快递地址";
      return question;
    },

    // 性别题
    gender() {
      let question = this.radio();
      question.title = "您的性别是？";
      question.description = "请选择您的性别";
      question.options = [
        {
          id: uuid(this.timestamp),
          text: "男性",
          setting: {
            show: false,
            text: "",
            required: true,
            validate: ""
          }
        },
        {
          id: uuid(this.timestamp),
          text: "女性",
          setting: {
            show: false,
            text: "",
            required: true,
            validate: ""
          }
        }
      ];
      return question;
    },
    // 性别题
    satisfaction() {
      let question = this.radio();
      question.title = "您对我们的产品总体印象？";
      question.description = "您的反馈是我们持续改善我们产品质量的依据";
      question.options = [
        {
          id: uuid(this.timestamp),
          text: "满意",
          setting: {
            show: false,
            text: "",
            required: true,
            validate: ""
          }
        },
        {
          id: uuid(this.timestamp),
          text: "较满意",
          setting: {
            show: false,
            text: "",
            required: true,
            validate: ""
          }
        },
        {
          id: uuid(this.timestamp),
          text: "一般",
          setting: {
            show: false,
            text: "",
            required: true,
            validate: ""
          }
        },
        {
          id: uuid(this.timestamp),
          text: "不满意",
          setting: {
            show: false,
            text: "",
            required: true,
            validate: ""
          }
        }
      ];
      return question;
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/variables.less";

.question_type_wrap {
  width: 150px;
  height: calc(100vh - 64px);
  overflow: auto;
  background-color: #fafafa;
  position: fixed;
  top: 64px;
  left: 72px;
  z-index: 2;
  border-right: 1px solid #dde5ed;

  .title {
    font-size: 15px;
    padding: 20px 10px 0 10px;
    text-align: center;
    color: gray;
  }

  .type-item {
    cursor: pointer;
    text-align: center;
    height: 35px;
    line-height: 35px;
    vertical-align: middle;
    border: 1px solid #e0e0e0;
    background-color: #fff;
    margin: 10px;
    color: #707070;
    box-sizing: border-box;

    &:hover {
      border: 1px solid @deepblue;

      a {
        color: @deepblue;
      }
    }

    a {
      // display: block;
      height: 100%;
      font-size: 14px;
      pointer-events: none;
      color: #707070;

      .icon {
        text-align: center;
        vertical-align: center;
        padding-right: 5px;
      }
    }
  }
}
</style>
